// FlowBoxDeviceLogicController is gated by [ActiveSubscriptionAdminRequired], which returns 403 for non-admins.
export const flowBoxErrorMessage = (err, t, fallbackKey) =>
  err?.status === 403 ? t("flowBox.error.adminRequired") : t(fallbackKey);
